import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { Observable } from "rxjs";
// The generic scalar value model used by mutiple services
// It expects one integer value named "scalar"
import { ScalarResponseModel } from "../../models/scalar/scalar.model";

@Injectable({
    providedIn: 'root'
})
export class DeletedCustomersCountService {

    private DELETEDCUSTOMERSCOUNT_URL = 'api/deleteCustomersCount'

    constructor(
        private _httpClient: HttpClient
    ) {
    }

    get url(): string {

        return this.DELETEDCUSTOMERSCOUNT_URL;
    }

    // This is where Angular calls the REST service and makes the result "Observable:
    // so that it can be used elsewhere in the app
    getDeletedCustomersCount$(): Observable<ScalarResponseModel> {
        return this._httpClient.get<ScalarResponseModel>(this.DELETEDCUSTOMERSCOUNT_URL);
    }
}
